import React from 'react'
import styles from './styles'
import {RootState} from '../../redux/rootReducer'
import {connect} from 'react-redux'
import {Container, Typography} from '@material-ui/core'

type Props = {
  error?: Error
}

const ErrorView: React.FC<Props> = (props: Props) => {
  const {error} = props

  if (!error) {
    return null
  }
  return (
    <Container style={styles}>
      <Typography>{error.message}</Typography>
    </Container>
  )
}

export default connect(({app}: RootState) => ({error: app.error}))(ErrorView)
